export interface CsvUploadResult {
  created: number;
  errors: number;
  total_rows: number;
  row_errors: Array<{ row: number; error: string }>;
  message: string;
}

export function splitCsvRows(csvContent: string): string[] {
  const rows: string[] = [];
  let current = '';
  let inQuotes = false;

  for (const character of csvContent) {
    if (character === '"') {
      inQuotes = !inQuotes;
      current += character;
    } else if ((character === '\n' || character === '\r') && !inQuotes) {
      const trimmed = current.trim();
      if (trimmed) rows.push(trimmed);
      current = '';
    } else {
      current += character;
    }
  }

  if (current.trim()) rows.push(current.trim());
  return rows;
}

export function downloadCsvTemplate(contents: string, filename: string): void {
  const blob = new Blob([contents], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
